<mat-form-field [style.width]="'100%'" class="{{ look }}  loren-form-field">
  <mat-label>{{ "period.select_label" | transloco }}</mat-label>
  <mat-select
    [value]="periods[0]"
    (selectionChange)="onSelectionChange($event)">
    @for (period of periods; track period) {
      <mat-option [value]="period">
        {{ period.label | transloco }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
